import secureLocalStorage from "react-secure-storage";
import * as moment from "moment";
import { toastr } from "react-redux-toastr";

const MAINURL = process.env.REACT_APP_API_URL;

async function checkAuthentication() {
    try {
        let path = window.location.pathname;
        if (path) {
            let tenantKey = path.split("/")[2];
            let loginUserId = secureLocalStorage.getItem("loginUserId");
            if (secureLocalStorage.getItem("tenantKey").toLowerCase() === tenantKey.toLowerCase() && loginUserId) {
                return;
            } else {
                toastr.error('Your session has timed out. Please login again');
                window.location.href = `/${"tenant"}/${tenantKey}`;
            }
        }
    } catch (err) {
        console.log(err);
    }
}

async function userLogin(params) {
    const url = MAINURL + "/tenant/SuperAdminLogin";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function getTenantdata() {
    const url = MAINURL + "/tenant/List";
    const response = await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
    });
    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
}

async function tenantLogin(params) {
    const url = MAINURL + "/tenant/TenantLogin";
    let token = secureLocalStorage.getItem("authToken");
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function addTenant(params) {

    const url = MAINURL + "/tenant/Add";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });

    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
}
async function updateTenant(params) {
    const url = MAINURL + "/tenant/Update";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });

    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
}
async function userAddByTenant(params) {
    await checkAuthentication();
    const url = MAINURL + "/Users/Add";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });

    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
}

async function userUpdateByTenant(params) {
    await checkAuthentication();
    const url = MAINURL + "/Users/Update";
    const response = await fetch(url, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response;
}

async function getuserAddedByTenant(params) {
    await checkAuthentication();
    const url = MAINURL + "/Users/Get";
    const response = await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
    });
    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
}

async function getWorkstreamUsers(params) {
  await checkAuthentication();
  const url = MAINURL + "/Users/GetWorkstreamUsers";
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      TenantKey: secureLocalStorage.getItem("tenantKey"),
      Authorization: secureLocalStorage.getItem("authToken"),
      LoginType: secureLocalStorage.getItem("loggedClient"),
      loginUserId: secureLocalStorage.getItem("loginUserId"),
      requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
    },
  });
  const string = await response.text();
  const json = string === "" ? response : JSON.parse(string);
  return json;
}

async function resetPassword(params) {
    const url = MAINURL + "/tenant/ForgotPassword";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function resetPasswordData(params) {
    const url = MAINURL + "/tenant/ChangeForgotPassword";
    const response = await fetch(url, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function changePassword(params) {
    await checkAuthentication();
    const url = MAINURL + "/tenant/ChangePassword";
    const response = await fetch(url, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

// SSO
async function userAddViaSSO(params) {
    const url = MAINURL + "/Users/AddSsoUser";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function addOrgType(params) {
    await checkAuthentication();
    const url = MAINURL + "/organizationUnitType/add";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function updateOrgType(params) {
    await checkAuthentication();
    const url = MAINURL + "/organizationUnitType/update";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function removeOrgType(params) {
    await checkAuthentication();
    const url = MAINURL + "/organizationUnitType/delete";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function getOrgType() {
    await checkAuthentication();
    const url = MAINURL + "/organizationUnitType/get";
    const response = await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
    });
    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
}


async function addOrgUnit(params) {
    await checkAuthentication();
    const url = MAINURL + "/organizationUnit/add";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function editOrgUnit(params) {
    await checkAuthentication();
    const url = MAINURL + "/organizationUnit/update";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function updateOrgUnit(params) {
    await checkAuthentication();
    const url = MAINURL + "/organizationUnit/update";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function addProject(params) {
    await checkAuthentication();
    const url = MAINURL + "/project/add";
    var loggedClient = secureLocalStorage.getItem("loggedClient");
    var userID =
        loggedClient == "user"
            ? secureLocalStorage.getItem("userId")
            : secureLocalStorage.getItem("tenantId");
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response;
}

async function getProjects(params) {
    await checkAuthentication();
    const url = MAINURL + "/project/Get";
    var loggedClient = secureLocalStorage.getItem("loggedClient");
    var userID =
        loggedClient == "user"
            ? secureLocalStorage.getItem("userId")
            : secureLocalStorage.getItem("tenantId");
    const response = await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
    });
    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
}

async function getOrgUnits(params, type) {
    await checkAuthentication();
    const url = MAINURL + "/organizationUnit/get";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
            Type: type ? type : "USER"
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
}
async function enableUser(params) {
    await checkAuthentication();
    const url = MAINURL + "/tenant/enableAccount";
    const response = await fetch(url, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function addRiskType(params) {
    await checkAuthentication();
    const url = MAINURL + "/riskType/add";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function addProjectStage(params) {
    await checkAuthentication();
    const url = MAINURL + "/actionType/add";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function getRiskType(params) {
    await checkAuthentication();
    const url = MAINURL + "/riskType/get";
    const response = await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
    });
    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
}

async function addRiskRegister(params) {
    await checkAuthentication();
    const url = MAINURL + "/riskRegister/add";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function updateRiskRegister(params) {
    await checkAuthentication();
    const url = MAINURL + "/riskRegister/update";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function AddRiskRegisterForm(params) {
  await checkAuthentication();
  const url = MAINURL + "/riskRegister/AddRiskRegister";
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      TenantKey: secureLocalStorage.getItem("tenantKey"),
      Authorization: secureLocalStorage.getItem("authToken"),
      LoginType: secureLocalStorage.getItem("loggedClient"),
      loginUserId: secureLocalStorage.getItem("loginUserId"),
      requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
    },
    body: JSON.stringify({
      ...params,
    }),
  });
  return response.json();
}
async function getRiskRegister(params) {
    await checkAuthentication();
    const url = MAINURL + "/riskRegister/get";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function getOrgUnitForProject(params) {
    await checkAuthentication();
    const url = MAINURL + "/organizationUnit/getOrgUnitForProject";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function deleteDocumentById(params) {
    await checkAuthentication();
    var url = MAINURL + "/RiskWell/DeleteDocs";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken")
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function commonDocumentUpload(formData) {
    await checkAuthentication();
    var url = MAINURL + "/RiskWell/UploadDocs";
    const response = await fetch(url, {
        method: "Post",
        headers: {
            Authorization: secureLocalStorage.getItem("authToken")
        },
        body: formData,
    });
    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
}
// async function addDocument(formData) {
//     await checkAuthentication();
//     var url = MAINURL + "/ProjectDocs/UploadProjectDocs";
//     const response = await fetch(url, {
//         method: "Post",

//         body: formData,
//     });
//     const string = await response.text();
//     const json = string === "" ? response : JSON.parse(string);
//     return json;
// }

// async function addDocumentByiskId(formData) {
//     await checkAuthentication();
//     var loggedClient = secureLocalStorage.getItem("loggedClient");
//     var userID =
//         loggedClient == "user"
//             ? secureLocalStorage.getItem("userId")
//             : secureLocalStorage.getItem("tenantId");

//     var url = MAINURL + "/RiskRegisterDocs/UploadRiskDocs";
//     const response = await fetch(url, {
//         method: "Post",

//         body: formData,
//     });
//     const string = await response.text();
//     const json = string === "" ? response : JSON.parse(string);
//     return json;
// }

async function getCommonDocumentsList(params) {
    await checkAuthentication();
    const url = MAINURL + "/RiskWell/GetDocs";
    var loggedClient = secureLocalStorage.getItem("loggedClient");
    var userID =
        loggedClient == "user"
            ? secureLocalStorage.getItem("userId")
            : secureLocalStorage.getItem("tenantId");

    var headers;

    headers = {
        "Content-Type": "application/json",
        TenantKey: secureLocalStorage.getItem("tenantKey"),
        Authorization: secureLocalStorage.getItem("authToken"),
        // LoginType: secureLocalStorage.getItem("loggedClient"),
        // loginUserId: secureLocalStorage.getItem("loginUserId"),
        // requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        Id: params.id,
        DocType: params.type,
        // CreatedBy: userID,
    };

    const response = await fetch(url, {
        method: "Post",
        headers: headers,
    });

    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
}

// async function getDocuments(params) {
//     await checkAuthentication();
//     const url = MAINURL + "/ProjectDocs/GetProjectDocs";
//     var loggedClient = secureLocalStorage.getItem("loggedClient");
//     var userID =
//         loggedClient == "user"
//             ? secureLocalStorage.getItem("userId")
//             : secureLocalStorage.getItem("tenantId");

//     var headers;
//     if (params.type == "project") {
//         headers = {
//             "Content-Type": "application/json",
//             TenantKey: secureLocalStorage.getItem("tenantKey"),
//             Authorization: secureLocalStorage.getItem("authToken"),
//             LoginType: secureLocalStorage.getItem("loggedClient"),
//             loginUserId: secureLocalStorage.getItem("loginUserId"),
//             requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
//             ProjectId: params.id,
//             CreatedBy: userID,
//         };
//     }

//     const response = await fetch(url, {
//         method: "Post",
//         headers: headers,
//     });

//     const string = await response.text();
//     const json = string === "" ? response : JSON.parse(string);
//     return json;
// }

// async function getDocumentsByRiskId(params) {
//     await checkAuthentication();
//     const url = MAINURL + "/RiskRegisterDocs/GetRiskRegisterDocs";
//     var loggedClient = secureLocalStorage.getItem("loggedClient");
//     var userID =
//         loggedClient == "user"
//             ? secureLocalStorage.getItem("userId")
//             : secureLocalStorage.getItem("tenantId");

//     var headers;
//     if (params.type == "risk") {
//         headers = {
//             "Content-Type": "application/json",
//             TenantKey: secureLocalStorage.getItem("tenantKey"),
//             Authorization: secureLocalStorage.getItem("authToken"),
//             LoginType: secureLocalStorage.getItem("loggedClient"),
//             loginUserId: secureLocalStorage.getItem("loginUserId"),
//             requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
//             RiskRegisterId: params.id,
//             CreatedBy: userID,
//         };
//     }

//     const response = await fetch(url, {
//         method: "Post",
//         headers: headers,
//     });

//     const string = await response.text();
//     const json = string === "" ? response : JSON.parse(string);
//     return json;
// }

async function getProjectStage(params) {
    await checkAuthentication();
    const url = MAINURL + "/actionType/get";
    const response = await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
    });
    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
}
async function createRegisterMitigation(params) {
    await checkAuthentication();
    const url = MAINURL + "/RiskAction/Mitigation";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function getRegisterMitigation(riskId) {
    await checkAuthentication();
    const url = MAINURL + "/RiskAction/get";
    const response = await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
            RiskRegisterId: riskId,
        },
    });
    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
}
async function getOrgUnitById(params) {
    await checkAuthentication();
    const url = MAINURL + "/organizationUnit/getSingleOrgUnit";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function getSubMitigationList(RiskRegisterId, parentMitigationId) {
    await checkAuthentication();
    const url = MAINURL + "/RiskAction/GetSubMitigation";
    const response = await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            RiskRegisterId: RiskRegisterId,
            parentMitigationId: parentMitigationId,
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
    });
    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
}

async function updateUser(params) {
    await checkAuthentication();
    const url = MAINURL + "/Users/Update";
    const response = await fetch(url, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function deleteOrgUnit(params) {
    await checkAuthentication();
    const url = MAINURL + "/organizationUnit/delete";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function updateProject(params) {
    await checkAuthentication();
    const url = MAINURL + "/project/update";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function deleteProject(params) {
    await checkAuthentication();
    const url = MAINURL + "/project/delete";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function addImpact(params) {
    await checkAuthentication();
    const url = MAINURL + "/Impact/add";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function updateImpact(params) {
    await checkAuthentication();
    const url = MAINURL + "/Impact/update";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function RiskRegisterCalculation(params) {
  await checkAuthentication();
  const url = MAINURL + "/riskRegister/RiskRegisterCalculation";
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      TenantKey: secureLocalStorage.getItem("tenantKey"),
      Authorization: secureLocalStorage.getItem("authToken"),
      LoginType: secureLocalStorage.getItem("loggedClient"),
      loginUserId: secureLocalStorage.getItem("loginUserId"),
      requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
    },
    body: JSON.stringify({
      ...params,
    }),
  });
  return response.json();
}

async function deleteImpact(params) {
    await checkAuthentication();
    const url = MAINURL + "/Impact/delete";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function getImpact() {
    await checkAuthentication();
    const url = MAINURL + "/Impact/get";
    const response = await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
    });
    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
}


async function deleteRisk(params) {
    await checkAuthentication();
    const url = MAINURL + "/riskRegister/delete";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function deleteMitigation(params) {
    await checkAuthentication();
    const url = MAINURL + "/RiskAction/deleteMitigation";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function deleteSubMitigation(params) {
    await checkAuthentication();
    const url = MAINURL + "/RiskAction/deleteSubMitigation";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function emailVerification(params) {
    const url = MAINURL + "/Users/VerifySsoUser";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
    });
    return response.json();
}

async function getValidUrl(params) {
    const url = MAINURL + "/tenant/checkForgotPasswordLink";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function getImpactByRisk(params) {
    await checkAuthentication();
    const url = MAINURL + "/riskRegister/getImpact";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function getImpactByMitigation(params) {
    await checkAuthentication();
    const url = MAINURL + "/RiskAction/getMitigationImpact";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function addImpactByRisk(params) {
    await checkAuthentication();
    const url = MAINURL + "/riskRegister/AddImpact";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function addImpactByMitigation(params) {
    await checkAuthentication();
    const url = MAINURL + "/RiskAction/AddMitigationImpact";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function getRiskCount(params) {
    await checkAuthentication();
    const url = MAINURL + "/RiskRegister/GetRiskCount";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function getImpactRatingTable(params) {
    await checkAuthentication();
    const url = MAINURL + "/ImpactThreshold/GetAllImpactThreshold";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function saveDashboard(params) {
    await checkAuthentication();
    const url = MAINURL + "/dashboard/add";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function updateDashboard(params) {
    await checkAuthentication();
    const url = MAINURL + "/dashboard/update";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function deleteDashboard(params) {
    await checkAuthentication();
    const url = MAINURL + "/dashboard/delete";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function getDashboard(params) {
    await checkAuthentication();
    const url = MAINURL + "/dashboard/get";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function getWidgetType() {
    await checkAuthentication();
    const url = MAINURL + "/widget/getwidgettype";
    const response = await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
    });
    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
}
async function getQuadrantWidgetType() {
    await checkAuthentication();
    const url = MAINURL + "/Quadrant/getwidgettype";
    const response = await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
    });
    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
}
async function saveWidget(params) {
    await checkAuthentication();
    const url = MAINURL + "/widget/addwidget";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function getRiskForOrgUnit(params) {
    await checkAuthentication();
    const url = MAINURL + "/riskRegister/getRiskForOrgUnit";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function saveView(params) {
    await checkAuthentication();
    const url = MAINURL + "/view/add";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function getView(params) {
    await checkAuthentication();
    const url = MAINURL + "/view/get";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function getReportsByDashboardID(params) {
    await checkAuthentication();
    const url = MAINURL + "/widget/getwidget";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function getDashBoardList(params) {
    await checkAuthentication();
    const url = MAINURL + "/dashboard/getDashBoard";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function deleteWidget(params) {
    await checkAuthentication();
    const url = MAINURL + "/widget/delete";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function runMonteCarle(params) {
    await checkAuthentication();
    const url = MAINURL + "/monteCarlo/runTest";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function getRiskCountMonteCarlo(params) {
    await checkAuthentication();
    const url = MAINURL + "/RiskRegister/GetRiskCountMonteCarlo";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function getApprovedAggregateControl(params) {
    await checkAuthentication();
    const url = MAINURL + "/RiskAction/GetApprovedAggregateControl";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function getTimeStampDataByOrgIds(params) {
    await checkAuthentication();
    const url = MAINURL + "/timeStamp/getData";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function getMitigationByDataByOrgIds(params) {
    await checkAuthentication();
    const url = MAINURL + "/RiskAction/GetActionByOrgId";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function getLetestWidgetForHome(params) {
    await checkAuthentication();
    const url = MAINURL + "/widget/getLetestWidgetForHome";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function deleteView(params) {
    await checkAuthentication();
    const url = MAINURL + "/view/delete";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function MitigationCalculation(params) {
  await checkAuthentication();
  const url = MAINURL + "/RiskAction/MitigationCalculation";
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      TenantKey: secureLocalStorage.getItem("tenantKey"),
      Authorization: secureLocalStorage.getItem("authToken"),
      LoginType: secureLocalStorage.getItem("loggedClient"),
      loginUserId: secureLocalStorage.getItem("loginUserId"),
      requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
    },
    body: JSON.stringify({
      ...params,
    }),
  });
  return response.json();
}

async function updateView(params) {
    await checkAuthentication();
    const url = MAINURL + "/view/update";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function getByViewId(params) {
    await checkAuthentication();
    const url = MAINURL + "/view/getView";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function getHeatMapByViewId(params) {
    await checkAuthentication();
    const url = MAINURL + "/view/getHeatmapView";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function getTimestampHeatMapByViewId(params) {
    await checkAuthentication();
    const url = MAINURL + "/view/getTimestampHeatmapView";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function getMitigationViewAxis(params) {
    await checkAuthentication();
    const url = MAINURL + "/view/getAxesNames";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function addImportData(params) {
    await checkAuthentication();
    const url = MAINURL + "/RiskAction/AddImportData";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function getAdminRiskType(params) {
    await checkAuthentication();
    const url = MAINURL + "/RiskType/get";
    const response = await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
    });
    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
}
async function updateRiskType(params) {
    await checkAuthentication();
    const url = MAINURL + "/riskType/Update";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function deleteRiskType(params) {
    await checkAuthentication();
    const url = MAINURL + "/riskType/Delete";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function updateProjectStage(params) {
    await checkAuthentication();
    const url = MAINURL + "/actionType/Update";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function deleteProjectStage(params) {
    await checkAuthentication();
    const url = MAINURL + "/actionType/Delete";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function getScenarioRisksByOrgIds(params) {
    await checkAuthentication();
    const url = MAINURL + "/scenario/get";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function deleteScenario(params) {
    await checkAuthentication();
    const url = MAINURL + "/scenario/Delete";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function saveScenario(params) {
    await checkAuthentication();
    const url = MAINURL + "/scenario/save";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function updateScenario(params) {
    await checkAuthentication();
    const url = MAINURL + "/scenario/Update";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function runScenarioMontecarlo(params) {
    await checkAuthentication();
    const url = MAINURL + "/scenario/monteCarloForScenario";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function getRiskByRiskIds(params) {
    await checkAuthentication();
    const url = MAINURL + "/riskRegister/getRisksById";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function getQuadrantWidget(params) {
    await checkAuthentication();
    const url = MAINURL + "/Quadrant/getQuadrantWidget";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function generateQuadrantWidget(params) {
    await checkAuthentication();
    const url = MAINURL + "/Quadrant/quadrantGetWidget";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function viewQuadrantCounts(params) {
    await checkAuthentication();
    const url = MAINURL + "/Quadrant/viewAggregation";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function saveWQuadrantReport(params) {
    await checkAuthentication();
    const url = MAINURL + "/Quadrant/saveWQuadrantReport";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function saveQuadrantAggregation(params) {
    await checkAuthentication();
    const url = MAINURL + "/Quadrant/QuadrantAggregation";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function GetQuadrantAggregation(params) {
    await checkAuthentication();
    const url = MAINURL + "/Quadrant/GetQuadrantAggregation";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function getSavedScenario(params) {
    await checkAuthentication();
    const url = MAINURL + "/scenario/getSavedScenario";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function GetSavedScenarioRisk(params) {
    await checkAuthentication();
    const url = MAINURL + "/scenario/GetSavedScenarioRisk";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function PmoUserUpdate(params) {
    await checkAuthentication();
    const url = MAINURL + "/Users/PmoUserUpdate";
    const response = await fetch(url, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function GetSingleuser(params) {
    await checkAuthentication();
    const url = MAINURL + "/Users/GetSingleuser";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function GetUsersWithoutPMO(params) {
    await checkAuthentication();
    const url = MAINURL + "/Users/GetUsersWithoutPMO";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function GetPMOUsers(params) {
    await checkAuthentication();
    const url = MAINURL + "/Users/GetPMOUsers";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function shareWidgetToUser(formData) {
    await checkAuthentication();
    var url = MAINURL + "/widget/share";
    const response = await fetch(url, {
        method: "Post",
        headers: {
        //   "Content-Type": "application/json",
        //   TenantKey: secureLocalStorage.getItem("tenantKey"),
           Authorization: secureLocalStorage.getItem("authToken"),
        //   LoginType: secureLocalStorage.getItem("loggedClient"),
        //   loginUserId: secureLocalStorage.getItem("loginUserId"),
        //   requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: formData,
    });
    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
}
async function WidgetHome(params) {
    await checkAuthentication();
    const url = MAINURL + "/widget/WidgetHome";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function getMitigationFromView(params) {
    await checkAuthentication();
    const url = MAINURL + "/view/getMitigationFromView";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function getHistoricView(params) {
    await checkAuthentication();
    const url = MAINURL + "/view/getHistoricView";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function getHistoricViews(params) {
    await checkAuthentication();
    const url = MAINURL + "/view/getHistoricViews";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function HistoricQuadrantAggregation(params) {
    await checkAuthentication();
    const url = MAINURL + "/HistoricQuadrant/HistoricQuadrantAggregation";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function GetHistoricQuadrantAggregation(params) {
    await checkAuthentication();
    const url = MAINURL + "/HistoricQuadrant/GetHistoricQuadrantAggregation";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function getHistoricQuadrantWidget(params) {
    await checkAuthentication();
    const url = MAINURL + "/HistoricQuadrant/getHistoricQuadrantWidget";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function viewHistoricAggregation(params) {
    await checkAuthentication();
    const url = MAINURL + "/HistoricQuadrant/viewHistoricAggregation";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function getHistoricViewByDate(params) {
    await checkAuthentication();
    const url = MAINURL + "/view/getHistoricViewByDate";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function saveHistoricQuadrantReport(params) {
    await checkAuthentication();
    const url = MAINURL + "/HistoricQuadrant/saveHistoricQuadrantReport";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function HistoricQuadrantGetWidget(params) {
    await checkAuthentication();
    const url = MAINURL + "/HistoricQuadrant/HistoricQuadrantGetWidget";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function RemoveHistoricQuadrant(params) {
    await checkAuthentication();
    const url = MAINURL + "/view/DeleteHistoricView";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function GetHirtoricRisk(params) {
    await checkAuthentication();
    const url = MAINURL + "/HistoricQuadrant/GetHirtoricRisk";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function AddTemplate(params) {
    await checkAuthentication();
    const url = MAINURL + "/Email/AddTemplate";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function UpdateTemplate(params) {
    await checkAuthentication();
    const url = MAINURL + "/Email/UpdateTemplate";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function DeleteTemplate(params) {
    await checkAuthentication();
    const url = MAINURL + "/Email/DeleteTemplate";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function GetTemplate(params) {
    await checkAuthentication();
    const url = MAINURL + "/Email/GetTemplate";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function GetCartList(params) {
    await checkAuthentication();
    const url = MAINURL + "/Email/GetTemplateList";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function AddCart(params) {
    await checkAuthentication();
    const url = MAINURL + "/Email/AddCart";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function DeleteCart(params) {
    await checkAuthentication();
    const url = MAINURL + "/Email/DeleteCart";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function GetSinglewidget(params) {
    await checkAuthentication();
    const url = MAINURL + "/widget/GetSinglewidget";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function GetCartItems(params) {
    await checkAuthentication();
    const url = MAINURL + "/Email/GetCartItems";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function CartSendMail(params) {
    await checkAuthentication();
    const url = MAINURL + "/Email/SendMail";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function getEmailSuggestion() {
    await checkAuthentication();
    const url = MAINURL + "/Email/Suggestions";
    const response = await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
    });
    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
}

async function deleteUser(params) {
    await checkAuthentication();
    const url = MAINURL + "/Users/delete";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function getDeletedUser() {
    await checkAuthentication();
    const url = MAINURL + "/Users/GetDeletedUser";
    const response = await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
    });
    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
}

async function AvailableUsers() {
    await checkAuthentication();
    const url = MAINURL + "/Users/AvailableUsers";
    const response = await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
    });
    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
}


async function RecycleUser(params) {
    await checkAuthentication();
    const url = MAINURL + "/Users/RecycleUser";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function ShareQuadrant(params) {
    await checkAuthentication();
    const url = MAINURL + "/view/ShareQuadrant";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function addCustomField(params) {
    await checkAuthentication();
    const url = MAINURL + "/CustomFields/Add";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function updateCustomField(params) {
    await checkAuthentication();
    const url = MAINURL + "/CustomFields/Update";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function deleteCustomField(params) {
    await checkAuthentication();
    const url = MAINURL + "/CustomFields/Delete";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function getCustomField(params) {
    await checkAuthentication();
    const url = MAINURL + "/CustomFields/Get";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function AddImpactThreshold(params) {
    await checkAuthentication();
    const url = MAINURL + "/ImpactThreshold/AddImpactAndThreshold";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function updateImpactThreshold(params) {
    await checkAuthentication();
    const url = MAINURL + "/ImpactThreshold/UpdateImpactAndThreshold";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function getAllImpactThreshold() {
    await checkAuthentication();
    const url = MAINURL + "/ImpactThreshold/GetAllImpactAndThreshold";
    const response = await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
    });
    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
}

async function getImpactThresholdByImpactId(params) {
    await checkAuthentication();
    const url = MAINURL + "/ImpactThreshold/GetImpactAndThresholdByImpactId";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function deleteImpactThreshold(params) {
    await checkAuthentication();
    const url = MAINURL + "/ImpactThreshold/DeleteImpactAndThreshold";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function GetAllImpactAndThreshold() {
    await checkAuthentication();
    const url = MAINURL + "/ImpactThreshold/GetAllImpactAndThreshold";
    const response = await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
    });
    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
}
async function GetAllImpactThresholdForDataset(_type, params) {
    await checkAuthentication();
    const url = MAINURL + "/ImpactThreshold/GetAllImpactThresholdForDataset";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
            type: _type
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function GetProbabilityRange() {
    await checkAuthentication();
    const url = MAINURL + "/ProbabilityRange/GetProbabilityRange";
    const response = await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
    });
    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
}

async function UpdateProbabilityRange(params) {
    await checkAuthentication();
    const url = MAINURL + "/ProbabilityRange/UpdateProbabilityRange";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function getAllOwnerrList(params) {
    await checkAuthentication();
    const url = MAINURL + "/riskRegister/GetOwnerByRisk";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function riskProgressComments(params) {
    await checkAuthentication();
    const url = MAINURL + "/riskRegister/RiskProgressComments";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function actionProgressComments(params) {
    await checkAuthentication();
    const url = MAINURL + "/RiskAction/ActionProgressComments";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function copyRisks(params) {
    await checkAuthentication();
    const url = MAINURL + "/RiskRegister/CopyRisks";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function getAllWorkstream(params) {
    await checkAuthentication();
    const url = MAINURL + "/organizationUnit/getAllWorkstream";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function widgetDuplicationCheck(params) {
    await checkAuthentication();
    const url = MAINURL + "/widget/WidgetDuplicationCheck";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

//Persistence
async function getPersistance(params) {
    await checkAuthentication();
    const url = MAINURL + "/riskRegister/GetPersistance";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function widgetPersist(params) {
    await checkAuthentication();
    const url = MAINURL + "/widget/WidgetPersist";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function persistRisks(params) {
    await checkAuthentication();
    const url = MAINURL + "/riskRegister/PersistRisks";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function persistAction(params) {
    await checkAuthentication();
    const url = MAINURL + "/RiskAction/PersistAction";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function getPersistanceAction(params) {
    await checkAuthentication();
    const url = MAINURL + "/RiskAction/GetPersistance";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function homeRisksByOwner(ownerId) {
  await checkAuthentication();
  const url = MAINURL + "/riskRegister/HomeRisksByOwner";
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      TenantKey: secureLocalStorage.getItem("tenantKey"),
      Authorization: secureLocalStorage.getItem("authToken"),
      LoginType: secureLocalStorage.getItem("loggedClient"),
      loginUserId: secureLocalStorage.getItem("loginUserId"),
      OwnerId:ownerId,
      requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
    },
  });
  const string = await response.text();
  const json = string === "" ? response : JSON.parse(string);
  return json;
}
async function homeActionsByOwner(ownerId) {
  await checkAuthentication();
  const url = MAINURL + "/riskAction/HomeActionsByOwner";
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      TenantKey: secureLocalStorage.getItem("tenantKey"),
      Authorization: secureLocalStorage.getItem("authToken"),
      LoginType: secureLocalStorage.getItem("loggedClient"),
      loginUserId: secureLocalStorage.getItem("loginUserId"),
      OwnerId:ownerId,
      requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
    },
  });
  const string = await response.text();
  const json = string === "" ? response : JSON.parse(string);
  return json;
}
async function widgetTextNarrative(params) {
    await checkAuthentication();
    const url = MAINURL + "/widget/saveTextNarrative";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function dashboardTextNarrative(params) {
    await checkAuthentication();
    const url = MAINURL + "/dashboard/saveTextNarrative";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function homeWidgetPersist(params) {
    await checkAuthentication();
    const url = MAINURL + "/widget/HomeWidgetPersist";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function persistHomeRisks(params) {
    await checkAuthentication();
    const url = MAINURL + "/riskRegister/PersistHomeRisks";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function getHomeRiskPersistance(params) {
    await checkAuthentication();
    const url = MAINURL + "/riskRegister/GetHomeRiskPersistance";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function getHomePersistance(params) {
    await checkAuthentication();
    const url = MAINURL + "/RiskAction/GetHomePersistance";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function persistHomeAction(params) {
    await checkAuthentication();
    const url = MAINURL + "/RiskAction/PersistHomeAction";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function qualitativeAdd(params) {
    await checkAuthentication();
    const url = MAINURL + "/QualitativeImpact/Add";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function qualitativeEdit(params) {
    await checkAuthentication();
    const url = MAINURL + "/QualitativeImpact/Update";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function qualitativeGet(params) {
    await checkAuthentication();
    const url = MAINURL + "/QualitativeImpact/Get";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function qualitativeDelete(params) {
    await checkAuthentication();
    const url = MAINURL + "/QualitativeImpact/Delete";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function addQualitativeImpact(params) {
    await checkAuthentication();
    const url = MAINURL + "/riskRegister/AddQualitativeImpact";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function freezeDashboard(params) {
    await checkAuthentication();
    const url = MAINURL + "/widget/FreezeDashboard";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}


async function getFrozenDashboard(params) {
    await checkAuthentication();
    const url = MAINURL + "/dashboard/getSharedFrozenDashboard";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function getFrozenWidgets(params) {
    await checkAuthentication();
    const url = MAINURL + "/widget/GetFrozenWidgets";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function deleteFrozenDashboard(params) {
    await checkAuthentication();
    const url = MAINURL + "/widget/DeleteFrozenDashboard";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function updateFrozenDashboard(params) {
    await checkAuthentication();
    const url = MAINURL + "/widget/UpdateFrozenDashboard";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function getFrozenDataset(params) {
    await checkAuthentication();
    const url = MAINURL + "/widget/GetFrozenDataset";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function getImpactsByWorkstream(params) {
    await checkAuthentication();
    const url = MAINURL + "/view/GetImpactsByWorkstream";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function calculateWeightages(params) {
    await checkAuthentication();
    const url = MAINURL + "/Prime/ConsistancyRatio";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function AddPrimeMatrix(params) {
    await checkAuthentication();
    const url = MAINURL + "/Prime/AddPrimeMatrix";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function UpdatePrimeMatrix(params) {
    await checkAuthentication();
    const url = MAINURL + "/Prime/UpdatePrimeMatrix";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function DeletePrimeMatrix(params) {
    await checkAuthentication();
    const url = MAINURL + "/Prime/DeletePrimeMatrix";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function GetPrimeMatrix(params) {
    await checkAuthentication();
    const url = MAINURL + "/Prime/GetPrimeMatrix";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}
async function GetAllPrimeMatrix() {
    const url = MAINURL + "/Prime/GetAllPrimeMatrix";
    const response = await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
    });
    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
}
async function AddCurrency(params) {
  await checkAuthentication();
  const url = MAINURL + "/CurrencyType/add";
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      TenantKey: secureLocalStorage.getItem("tenantKey"),
      Authorization: secureLocalStorage.getItem("authToken"),
      LoginType: secureLocalStorage.getItem("loggedClient"),
      loginUserId: secureLocalStorage.getItem("loginUserId"),
      requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
    },
    body: JSON.stringify({
      ...params,
    }),
  });
  return response.json();
}

async function GetCurrency() {
  const url = MAINURL + "/CurrencyType/get";
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      TenantKey: secureLocalStorage.getItem("tenantKey"),
      Authorization: secureLocalStorage.getItem("authToken"),
      LoginType: secureLocalStorage.getItem("loggedClient"),
      loginUserId: secureLocalStorage.getItem("loginUserId"),
      requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
    },
  });
  const string = await response.text();
  const json = string === "" ? response : JSON.parse(string);
  return json;
}
async function AddPersist(params) {
  await checkAuthentication();
  const url = MAINURL + "/persist/AddPersist";
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      TenantKey: secureLocalStorage.getItem("tenantKey"),
      Authorization: secureLocalStorage.getItem("authToken"),
      LoginType: secureLocalStorage.getItem("loggedClient"),
      loginUserId: secureLocalStorage.getItem("loginUserId"),
      requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
    },
    body: JSON.stringify({
      ...params,
    }),
  });
  return response.json();
}


async function getPersist(params) {
  await checkAuthentication();
  const url = MAINURL + "/persist/GetPersist";
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      TenantKey: secureLocalStorage.getItem("tenantKey"),
      Authorization: secureLocalStorage.getItem("authToken"),
      LoginType: secureLocalStorage.getItem("loggedClient"),
      loginUserId: secureLocalStorage.getItem("loginUserId"),
      requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
    },
    body: JSON.stringify({
      ...params,
    }),
  });
  return response.json();
}
async function SaveMatrixColor(params){
  await checkAuthentication();
  const url = MAINURL + "/MatrixColor/add";
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      TenantKey: secureLocalStorage.getItem("tenantKey"),
      Authorization: secureLocalStorage.getItem("authToken"),
      LoginType: secureLocalStorage.getItem("loggedClient"),
      loginUserId: secureLocalStorage.getItem("loginUserId"),
      requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
    },
    body: JSON.stringify({
      ...params,
    }),
  });
  return response.json();

}

async function MatrixColor() {
  const url = MAINURL + "/MatrixColor/get";
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      TenantKey: secureLocalStorage.getItem("tenantKey"),
      Authorization: secureLocalStorage.getItem("authToken"),
      LoginType: secureLocalStorage.getItem("loggedClient"),
      loginUserId: secureLocalStorage.getItem("loginUserId"),
      requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
    },
  });
  const string = await response.text();
  const json = string === "" ? response : JSON.parse(string);
  return json;
}


async function UserPasswordReset(params) {
  const url = MAINURL + "/Users/UserPasswordReset";
  const response = await fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      TenantKey: secureLocalStorage.getItem("tenantKey"),
      Authorization: secureLocalStorage.getItem("authToken"),
      LoginType: secureLocalStorage.getItem("loggedClient"),
      loginUserId: secureLocalStorage.getItem("loginUserId"),
      requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
    },
    body: JSON.stringify({
      ...params,
    }),
  });
  return response.json();
}
async function GetHeatmapConfiguration() {
  const url = MAINURL + "/tenant/GetHeatmapConfiguration";
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      TenantKey: secureLocalStorage.getItem("tenantKey"),
      Authorization: secureLocalStorage.getItem("authToken"),
      LoginType: secureLocalStorage.getItem("loggedClient"),
      loginUserId: secureLocalStorage.getItem("loginUserId"),
      requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
    },
  });
  const string = await response.text();
  const json = string === "" ? response : JSON.parse(string);
  return json;
}

async function getRiskwellColumnsForRisk() {
    const url = MAINURL + "/ExcelTemplate/GetRiskwellColumnsForRisk";
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        TenantKey: secureLocalStorage.getItem("tenantKey"),
        Authorization: secureLocalStorage.getItem("authToken"),
        LoginType: secureLocalStorage.getItem("loggedClient"),
        loginUserId: secureLocalStorage.getItem("loginUserId"),
        requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
      },
    });
    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
  }
  async function getRiskwellColumnsForAction() {
    const url = MAINURL + "/ExcelTemplate/GetRiskwellColumnsForAction";
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        TenantKey: secureLocalStorage.getItem("tenantKey"),
        Authorization: secureLocalStorage.getItem("authToken"),
        LoginType: secureLocalStorage.getItem("loggedClient"),
        loginUserId: secureLocalStorage.getItem("loginUserId"),
        requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
      },
    });
    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
  }

  async function addExcelTemplate(params) {
    await checkAuthentication();
    const url = MAINURL + "/ExcelTemplate/AddExcelTemplate";
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        TenantKey: secureLocalStorage.getItem("tenantKey"),
        Authorization: secureLocalStorage.getItem("authToken"),
        LoginType: secureLocalStorage.getItem("loggedClient"),
        loginUserId: secureLocalStorage.getItem("loginUserId"),
        requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
      },
      body: JSON.stringify({
        ...params,
      }),
    });
    return response.json();
  }
  async function updateExcelTemplate(params) {
    await checkAuthentication();
    const url = MAINURL + "/ExcelTemplate/UpdateExcelTemplate";
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        TenantKey: secureLocalStorage.getItem("tenantKey"),
        Authorization: secureLocalStorage.getItem("authToken"),
        LoginType: secureLocalStorage.getItem("loggedClient"),
        loginUserId: secureLocalStorage.getItem("loginUserId"),
        requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
      },
      body: JSON.stringify({
        ...params,
      }),
    });
    return response.json();
  }
  async function deleteExcelTemplate(params) {
    await checkAuthentication();
    const url = MAINURL + "/ExcelTemplate/DeleteExcelTemplate";
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        TenantKey: secureLocalStorage.getItem("tenantKey"),
        Authorization: secureLocalStorage.getItem("authToken"),
        LoginType: secureLocalStorage.getItem("loggedClient"),
        loginUserId: secureLocalStorage.getItem("loginUserId"),
        requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
      },
      body: JSON.stringify({
        ...params,
      }),
    });
    return response.json();
  }
  async function getExcelTemplates() {
    const url = MAINURL + "/ExcelTemplate/GetExcelTemplates";
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        TenantKey: secureLocalStorage.getItem("tenantKey"),
        Authorization: secureLocalStorage.getItem("authToken"),
        LoginType: secureLocalStorage.getItem("loggedClient"),
        loginUserId: secureLocalStorage.getItem("loginUserId"),
        requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
      },
    });
    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
  }
  async function getExcelTemplateById(params) {
    await checkAuthentication();
    const url = MAINURL + "/ExcelTemplate/GetExcelTemplateById";
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        TenantKey: secureLocalStorage.getItem("tenantKey"),
        Authorization: secureLocalStorage.getItem("authToken"),
        LoginType: secureLocalStorage.getItem("loggedClient"),
        loginUserId: secureLocalStorage.getItem("loginUserId"),
        requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
      },
      body: JSON.stringify({
        ...params,
      }),
    });
    return response.json();
  }
  async function saveRisksByExcelUpload(params) {
    await checkAuthentication();
    const url = MAINURL + "/ExcelTemplate/SaveRisksByExcelUpload";
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        TenantKey: secureLocalStorage.getItem("tenantKey"),
        Authorization: secureLocalStorage.getItem("authToken"),
        LoginType: secureLocalStorage.getItem("loggedClient"),
        loginUserId: secureLocalStorage.getItem("loginUserId"),
        requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
      },
      body: JSON.stringify({
        ...params,
      }),
    });
    return response.json();
  }
  async function saveActionsByExcelUpload(params) {
    await checkAuthentication();
    const url = MAINURL + "/ExcelTemplate/SaveActionsByExcelUpload";
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        TenantKey: secureLocalStorage.getItem("tenantKey"),
        Authorization: secureLocalStorage.getItem("authToken"),
        LoginType: secureLocalStorage.getItem("loggedClient"),
        loginUserId: secureLocalStorage.getItem("loginUserId"),
        requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
      },
      body: JSON.stringify({
        ...params,
      }),
    });
    return response.json();
  }
  async function commitRisksByExcelUpload(params) {
    await checkAuthentication();
    const url = MAINURL + "/ExcelTemplate/CommitRisksByExcelUpload";
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        TenantKey: secureLocalStorage.getItem("tenantKey"),
        Authorization: secureLocalStorage.getItem("authToken"),
        LoginType: secureLocalStorage.getItem("loggedClient"),
        loginUserId: secureLocalStorage.getItem("loginUserId"),
        requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
      },
      body: JSON.stringify({
        ...params,
      }),
    });
    return response.json();
  }
  async function commitActionsByExcelUpload(params) {
    await checkAuthentication();
    const url = MAINURL + "/ExcelTemplate/CommitActionsByExcelUpload";
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        TenantKey: secureLocalStorage.getItem("tenantKey"),
        Authorization: secureLocalStorage.getItem("authToken"),
        LoginType: secureLocalStorage.getItem("loggedClient"),
        loginUserId: secureLocalStorage.getItem("loginUserId"),
        requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
      },
      body: JSON.stringify({
        ...params,
      }),
    });
    return response.json();
  }
  async function getTemporaryRiskListForUploader(params) {
    await checkAuthentication();
    const url = MAINURL + "/ExcelTemplate/GetTemporaryRiskListForUploader";
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        TenantKey: secureLocalStorage.getItem("tenantKey"),
        Authorization: secureLocalStorage.getItem("authToken"),
        LoginType: secureLocalStorage.getItem("loggedClient"),
        loginUserId: secureLocalStorage.getItem("loginUserId"),
        requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
      },
      body: JSON.stringify({
        ...params,
      }),
    });
    return response.json();
  }
  async function getTemporaryActionListForUploader(params) {
    await checkAuthentication();
    const url = MAINURL + "/ExcelTemplate/GetTemporaryActionListForUploader";
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        TenantKey: secureLocalStorage.getItem("tenantKey"),
        Authorization: secureLocalStorage.getItem("authToken"),
        LoginType: secureLocalStorage.getItem("loggedClient"),
        loginUserId: secureLocalStorage.getItem("loginUserId"),
        requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
      },
      body: JSON.stringify({
        ...params,
      }),
    });
    return response.json();
  }
  async function fetchPendingCommitForWorkstream(params) {
    await checkAuthentication();
    const url = MAINURL + "/ExcelTemplate/FetchPendingCommitForWorkstream";
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        TenantKey: secureLocalStorage.getItem("tenantKey"),
        Authorization: secureLocalStorage.getItem("authToken"),
        LoginType: secureLocalStorage.getItem("loggedClient"),
        loginUserId: secureLocalStorage.getItem("loginUserId"),
        requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
      },
      body: JSON.stringify({
        ...params,
      }),
    });
    return response.json();
  }
  async function saveColumnSettings(params) {
    await checkAuthentication();
    const url = MAINURL + "/RiskRegister/SaveColumnSettings";
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        TenantKey: secureLocalStorage.getItem("tenantKey"),
        Authorization: secureLocalStorage.getItem("authToken"),
        LoginType: secureLocalStorage.getItem("loggedClient"),
        loginUserId: secureLocalStorage.getItem("loginUserId"),
        requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
      },
      body: JSON.stringify({
        ...params,
      }),
    });
    return response.json();
  }
  async function getColumnSettings(params) {
    await checkAuthentication();
    const url = MAINURL + "/RiskRegister/GetColumnSettings";
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        TenantKey: secureLocalStorage.getItem("tenantKey"),
        Authorization: secureLocalStorage.getItem("authToken"),
        LoginType: secureLocalStorage.getItem("loggedClient"),
        loginUserId: secureLocalStorage.getItem("loginUserId"),
        requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
      },
      body: JSON.stringify({
        ...params,
      }),
    });
    return response.json();
  }
  async function getEffortUnitsForTasks() {
    await checkAuthentication();
    const url = MAINURL + "/OrganizationUnit/getEffortUnitsForTasks";
    const response = await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
    });
    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
  }
  async function addTaskRegisterAsync(params) {
    await checkAuthentication();
    const url = MAINURL + "/TaskRegister/addTaskRegisterAsync";
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        TenantKey: secureLocalStorage.getItem("tenantKey"),
        Authorization: secureLocalStorage.getItem("authToken"),
        LoginType: secureLocalStorage.getItem("loggedClient"),
        loginUserId: secureLocalStorage.getItem("loginUserId"),
        requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
      },
      body: JSON.stringify({
        ...params,
      }),
    });
    return response.json();
  }
  async function getTasksById(params) {
    await checkAuthentication();
    const url = MAINURL + "/TaskRegister/getTasksByWorkstreamId";
    const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          TenantKey: secureLocalStorage.getItem("tenantKey"),
          Authorization: secureLocalStorage.getItem("authToken"),
          LoginType: secureLocalStorage.getItem("loggedClient"),
          loginUserId: secureLocalStorage.getItem("loginUserId"),
          requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
          ...params,
        }),
      });
      return response.json();
  }
  async function deleteTask(params) {
    await checkAuthentication();
    const url = MAINURL + "/TaskRegister/deleteTask";
    const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          TenantKey: secureLocalStorage.getItem("tenantKey"),
          Authorization: secureLocalStorage.getItem("authToken"),
          LoginType: secureLocalStorage.getItem("loggedClient"),
          loginUserId: secureLocalStorage.getItem("loginUserId"),
          requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
          ...params,
        }),
      });
      return response.json();
  }

  async function getTaskMetricsAsync(params) {
    await checkAuthentication();
    const url = MAINURL + "/TaskRegister/getTaskMetricsAsync";
    const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          TenantKey: secureLocalStorage.getItem("tenantKey"),
          Authorization: secureLocalStorage.getItem("authToken"),
          LoginType: secureLocalStorage.getItem("loggedClient"),
          loginUserId: secureLocalStorage.getItem("loginUserId"),
          requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
          ...params,
        }),
      });
      return response.json();
  }

  async function addTaskAction(params) {
    await checkAuthentication();
    const url = MAINURL + "/TaskAction/addTaskAction";
    const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          TenantKey: secureLocalStorage.getItem("tenantKey"),
          Authorization: secureLocalStorage.getItem("authToken"),
          LoginType: secureLocalStorage.getItem("loggedClient"),
          loginUserId: secureLocalStorage.getItem("loginUserId"),
          requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
          ...params,
        }),
      });
      return response.json();
  }

  async function deleteTaskAction(params) {
    await checkAuthentication();
    const url = MAINURL + "/TaskAction/deleteTaskAction";
    const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          TenantKey: secureLocalStorage.getItem("tenantKey"),
          Authorization: secureLocalStorage.getItem("authToken"),
          LoginType: secureLocalStorage.getItem("loggedClient"),
          loginUserId: secureLocalStorage.getItem("loginUserId"),
          requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
          ...params,
        }),
      });
      return response.json();
  }
  async function homeTaskActionsByOwner(ownerId) {
    await checkAuthentication();
    const url = MAINURL + "/TaskAction/homeTaskActionsByOwner";
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        TenantKey: secureLocalStorage.getItem("tenantKey"),
        Authorization: secureLocalStorage.getItem("authToken"),
        LoginType: secureLocalStorage.getItem("loggedClient"),
        loginUserId: secureLocalStorage.getItem("loginUserId"),
        OwnerId:ownerId,
        requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
      },
    });
    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
  }
  async function homeTasksByOwner(ownerId) {
    await checkAuthentication();
    const url = MAINURL + "/TaskRegister/homeTasksByOwner";
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        TenantKey: secureLocalStorage.getItem("tenantKey"),
        Authorization: secureLocalStorage.getItem("authToken"),
        LoginType: secureLocalStorage.getItem("loggedClient"),
        loginUserId: secureLocalStorage.getItem("loginUserId"),
        OwnerId:ownerId,
        requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
      },
    });
    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
  }
  async function getTaskActionsByWorkstreamId(params) {
    await checkAuthentication();
    const url = MAINURL + "/TaskAction/getTaskActionsByWorkstreamId";
    const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          TenantKey: secureLocalStorage.getItem("tenantKey"),
          Authorization: secureLocalStorage.getItem("authToken"),
          LoginType: secureLocalStorage.getItem("loggedClient"),
          loginUserId: secureLocalStorage.getItem("loginUserId"),
          requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
          ...params,
        }),
      });
      return response.json();
  }

  async function getTaskDatasetView(params) {
    await checkAuthentication();
    const url = MAINURL + "/View/getTaskDatasetView";
    const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          TenantKey: secureLocalStorage.getItem("tenantKey"),
          Authorization: secureLocalStorage.getItem("authToken"),
          LoginType: secureLocalStorage.getItem("loggedClient"),
          loginUserId: secureLocalStorage.getItem("loginUserId"),
          requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
          ...params,
        }),
      });
      return response.json();
  }
  async function getTaskDatasetList(params) {
    await checkAuthentication();
    const url = MAINURL + "/View/getTaskDatasetList";
    const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          TenantKey: secureLocalStorage.getItem("tenantKey"),
          Authorization: secureLocalStorage.getItem("authToken"),
          LoginType: secureLocalStorage.getItem("loggedClient"),
          loginUserId: secureLocalStorage.getItem("loginUserId"),
          requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
          ...params,
        }),
      });
      return response.json();
  }
  async function getTaskActionDatasetView(params) {
    await checkAuthentication();
    const url = MAINURL + "/View/getTaskActionDatasetView";
    const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          TenantKey: secureLocalStorage.getItem("tenantKey"),
          Authorization: secureLocalStorage.getItem("authToken"),
          LoginType: secureLocalStorage.getItem("loggedClient"),
          loginUserId: secureLocalStorage.getItem("loginUserId"),
          requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
          ...params,
        }),
      });
      return response.json();
  }
  async function getTaskActionDatasetList(params) {
    await checkAuthentication();
    const url = MAINURL + "/View/getTaskActionDatasetList";
    const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          TenantKey: secureLocalStorage.getItem("tenantKey"),
          Authorization: secureLocalStorage.getItem("authToken"),
          LoginType: secureLocalStorage.getItem("loggedClient"),
          loginUserId: secureLocalStorage.getItem("loginUserId"),
          requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
          ...params,
        }),
      });
      return response.json();
  }
  async function getPriorityRankings() {
    await checkAuthentication();
    const url = MAINURL + "/TaskRegister/getPriorityRankings";
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        TenantKey: secureLocalStorage.getItem("tenantKey"),
        Authorization: secureLocalStorage.getItem("authToken"),
        LoginType: secureLocalStorage.getItem("loggedClient"),
        loginUserId: secureLocalStorage.getItem("loginUserId"),
        requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
      },
    });
    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
  }
  async function getFieldsForDataset(_type, params) {
    await checkAuthentication();
    const url = MAINURL + "/TaskRegister/getFieldsForDataset";
    const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          TenantKey: secureLocalStorage.getItem("tenantKey"),
          Authorization: secureLocalStorage.getItem("authToken"),
          LoginType: secureLocalStorage.getItem("loggedClient"),
          loginUserId: secureLocalStorage.getItem("loginUserId"),
          requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
          type: _type
        },
        body: JSON.stringify({
          ...params,
        }),
      });
      return response.json();
  }

  async function addTaskPersistence(params) {
    await checkAuthentication();
    const url = MAINURL + "/TaskRegister/addTaskPersistence";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function getTaskPersistence(params) {
    await checkAuthentication();
    const url = MAINURL + "/TaskRegister/getTaskPersistence";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function copyTasks(params) {
    await checkAuthentication();
    const url = MAINURL + "/TaskRegister/CopyTasks";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function getOwnersByTask(params) {
    await checkAuthentication();
    const url = MAINURL + "/TaskRegister/getOwnersByTask";
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            TenantKey: secureLocalStorage.getItem("tenantKey"),
            Authorization: secureLocalStorage.getItem("authToken"),
            LoginType: secureLocalStorage.getItem("loggedClient"),
            loginUserId: secureLocalStorage.getItem("loginUserId"),
            requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
        },
        body: JSON.stringify({
            ...params,
        }),
    });
    return response.json();
}

async function getRiskwellColumnsForTasks() {
    const url = MAINURL + "/ExcelTemplate/GetRiskwellColumnsForTasks";
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        TenantKey: secureLocalStorage.getItem("tenantKey"),
        Authorization: secureLocalStorage.getItem("authToken"),
        LoginType: secureLocalStorage.getItem("loggedClient"),
        loginUserId: secureLocalStorage.getItem("loginUserId"),
        requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
      },
    });
    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
  }

  async function getRiskwellColumnsForTaskActions() {
    const url = MAINURL + "/ExcelTemplate/GetRiskwellColumnsForTaskActions";
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        TenantKey: secureLocalStorage.getItem("tenantKey"),
        Authorization: secureLocalStorage.getItem("authToken"),
        LoginType: secureLocalStorage.getItem("loggedClient"),
        loginUserId: secureLocalStorage.getItem("loginUserId"),
        requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
      },
    });
    const string = await response.text();
    const json = string === "" ? response : JSON.parse(string);
    return json;
  }


  async function SaveTasksByExcelUpload(params) {
    await checkAuthentication();
    const url = MAINURL + "/ExcelTemplate/SaveTasksByExcelUpload";
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        TenantKey: secureLocalStorage.getItem("tenantKey"),
        Authorization: secureLocalStorage.getItem("authToken"),
        LoginType: secureLocalStorage.getItem("loggedClient"),
        loginUserId: secureLocalStorage.getItem("loginUserId"),
        requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
      },
      body: JSON.stringify({
        ...params,
      }),
    });
    return response.json();
  }
  async function SaveTaskActionsByExcelUpload(params) {
    await checkAuthentication();
    const url = MAINURL + "/ExcelTemplate/SaveTaskActionsByExcelUpload";
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        TenantKey: secureLocalStorage.getItem("tenantKey"),
        Authorization: secureLocalStorage.getItem("authToken"),
        LoginType: secureLocalStorage.getItem("loggedClient"),
        loginUserId: secureLocalStorage.getItem("loginUserId"),
        requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
      },
      body: JSON.stringify({
        ...params,
      }),
    });
    return response.json();
  }
  async function CommitTasksByExcelUpload(params) {
    await checkAuthentication();
    const url = MAINURL + "/ExcelTemplate/CommitTasksByExcelUpload";
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        TenantKey: secureLocalStorage.getItem("tenantKey"),
        Authorization: secureLocalStorage.getItem("authToken"),
        LoginType: secureLocalStorage.getItem("loggedClient"),
        loginUserId: secureLocalStorage.getItem("loginUserId"),
        requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
      },
      body: JSON.stringify({
        ...params,
      }),
    });
    return response.json();
  }
  async function CommitTaskActionsByExcelUpload(params) {
    await checkAuthentication();
    const url = MAINURL + "/ExcelTemplate/CommitTaskActionsByExcelUpload";
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        TenantKey: secureLocalStorage.getItem("tenantKey"),
        Authorization: secureLocalStorage.getItem("authToken"),
        LoginType: secureLocalStorage.getItem("loggedClient"),
        loginUserId: secureLocalStorage.getItem("loginUserId"),
        requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
      },
      body: JSON.stringify({
        ...params,
      }),
    });
    return response.json();
  }
  async function GetTemporaryTaskListForUploader(params) {
    await checkAuthentication();
    const url = MAINURL + "/ExcelTemplate/GetTemporaryTaskListForUploader";
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        TenantKey: secureLocalStorage.getItem("tenantKey"),
        Authorization: secureLocalStorage.getItem("authToken"),
        LoginType: secureLocalStorage.getItem("loggedClient"),
        loginUserId: secureLocalStorage.getItem("loginUserId"),
        requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
      },
      body: JSON.stringify({
        ...params,
      }),
    });
    return response.json();
  }
  async function GetTemporaryTaskActionsListForUploader(params) {
    await checkAuthentication();
    const url = MAINURL + "/ExcelTemplate/GetTemporaryTaskActionListForUploader";
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        TenantKey: secureLocalStorage.getItem("tenantKey"),
        Authorization: secureLocalStorage.getItem("authToken"),
        LoginType: secureLocalStorage.getItem("loggedClient"),
        loginUserId: secureLocalStorage.getItem("loginUserId"),
        requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
      },
      body: JSON.stringify({
        ...params,
      }),
    });
    return response.json();
  }
  async function updateUserWorkstreamSettings(params) {
    await checkAuthentication();
    const url = MAINURL + "/organizationUnit/updateUserWorkstreamSettings";
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        TenantKey: secureLocalStorage.getItem("tenantKey"),
        Authorization: secureLocalStorage.getItem("authToken"),
        LoginType: secureLocalStorage.getItem("loggedClient"),
        loginUserId: secureLocalStorage.getItem("loginUserId"),
        requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
      },
      body: JSON.stringify({
        ...params,
      }),
    });
    return response.json();
  }
   async function updateWidgetDetails(params) {
    await checkAuthentication();
    const url = MAINURL + "/widget/updateWidgetDetails";
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        TenantKey: secureLocalStorage.getItem("tenantKey"),
        Authorization: secureLocalStorage.getItem("authToken"),
        LoginType: secureLocalStorage.getItem("loggedClient"),
        loginUserId: secureLocalStorage.getItem("loginUserId"),
        requestDate: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
      },
      body: JSON.stringify({
        ...params,
      }),
    });
    return response.json();
  }
export default {
  checkAuthentication,
  userLogin,
  getTenantdata,
  tenantLogin,
  addTenant,
  userAddByTenant,
  getuserAddedByTenant,
  resetPassword,
  resetPasswordData,
  userAddViaSSO,
  changePassword,
  addOrgType,
  getOrgType,
  addOrgUnit,
  addProject,
  getProjects,
  getOrgUnits,
  enableUser,
  addRiskType,
  getRiskType,
  addRiskRegister,
  getRiskRegister,
  getOrgUnitForProject,
//   addDocument,
//   getDocuments,
  updateOrgUnit,
  getProjectStage,
  updateRiskRegister,
  getRegisterMitigation,
  createRegisterMitigation,
  getOrgUnitById,
//   getDocumentsByRiskId,
//   addDocumentByiskId,
  commonDocumentUpload,
  getCommonDocumentsList,
  getSubMitigationList,
  editOrgUnit,
  updateUser,
  userUpdateByTenant,
  deleteOrgUnit,
  updateProject,
  deleteProject,
  addProjectStage,
  deleteDocumentById,
  addImpact,
  updateImpact,
  getImpact,
  deleteImpact,
  deleteRisk,
  deleteMitigation,
  deleteSubMitigation,
  emailVerification,
  getValidUrl,
  getImpactByRisk,
  addImpactByRisk,
  getImpactByMitigation,
  addImpactByMitigation,
  getRiskCount,
  getImpactRatingTable,
  saveDashboard,
  updateDashboard,
  deleteDashboard,
  getDashboard,
  getWidgetType,
  saveWidget,
  getRiskForOrgUnit,
  saveView,
  getView,
  getReportsByDashboardID,
  getDashBoardList,
  deleteWidget,
  runMonteCarle,
  getRiskCountMonteCarlo,
  getApprovedAggregateControl,
  getTimeStampDataByOrgIds,
  getMitigationByDataByOrgIds,
  getLetestWidgetForHome,
  deleteView,
  getByViewId,
  getHeatMapByViewId,
  getTimestampHeatMapByViewId,
  updateView,
  getMitigationViewAxis,
  addImportData,
  getAdminRiskType,
  updateRiskType,
  deleteRiskType,
  updateProjectStage,
  deleteProjectStage,
  getScenarioRisksByOrgIds,
  saveScenario,
  runScenarioMontecarlo,
  getRiskByRiskIds,
  getQuadrantWidget,
  generateQuadrantWidget,
  getQuadrantWidgetType,
  viewQuadrantCounts,
  saveWQuadrantReport,
  saveQuadrantAggregation,
  GetQuadrantAggregation,
  updateOrgType,
  removeOrgType,
  getSavedScenario,
  GetSavedScenarioRisk,
  updateScenario,
  deleteScenario,
  PmoUserUpdate,
  GetSingleuser,
  GetPMOUsers,
  GetUsersWithoutPMO,
  shareWidgetToUser,
  WidgetHome,
  getMitigationFromView,
  getHistoricView,
  getHistoricViews,
  HistoricQuadrantAggregation,
  GetHistoricQuadrantAggregation,
  getHistoricQuadrantWidget,
  viewHistoricAggregation,
  getHistoricViewByDate,
  saveHistoricQuadrantReport,
  HistoricQuadrantGetWidget,
  RemoveHistoricQuadrant,
  GetHirtoricRisk,
  AddTemplate,
  UpdateTemplate,
  DeleteTemplate,
  GetTemplate,
  GetCartList,
  AddCart,
  DeleteCart,
  GetSinglewidget,
  GetCartItems,
  CartSendMail,
  getEmailSuggestion,
  updateTenant,
  deleteUser,
  getDeletedUser,
  AvailableUsers,
  RecycleUser,
  ShareQuadrant,
  addCustomField,
  updateCustomField,
  deleteCustomField,
  getCustomField,
  AddImpactThreshold,
  getAllImpactThreshold,
  deleteImpactThreshold,
  getImpactThresholdByImpactId,
  updateImpactThreshold,
  GetAllImpactAndThreshold,
  GetAllImpactThresholdForDataset,
  GetProbabilityRange,
  UpdateProbabilityRange,
  getAllOwnerrList,
  riskProgressComments,
  actionProgressComments,
  copyRisks,
  getAllWorkstream,
  widgetDuplicationCheck,
  getPersistance,
  widgetPersist,
  persistRisks,
  persistAction,
  getPersistanceAction,
  homeRisksByOwner,
  homeActionsByOwner,
  homeWidgetPersist,
  widgetTextNarrative,
  dashboardTextNarrative,
  persistHomeRisks,
  getHomeRiskPersistance,
  getHomePersistance,
  persistHomeAction,
  qualitativeAdd,
  qualitativeEdit,
  qualitativeGet,
  qualitativeDelete,
  addQualitativeImpact,
  freezeDashboard,
  getFrozenWidgets,
  getFrozenDashboard,
  deleteFrozenDashboard,
  updateFrozenDashboard,
  getFrozenDataset,
  getImpactsByWorkstream,
  calculateWeightages,
  AddPrimeMatrix,
  UpdatePrimeMatrix,
  DeletePrimeMatrix,
  GetPrimeMatrix,
  GetAllPrimeMatrix,
  AddCurrency,
  GetCurrency,
  AddPersist,
  getPersist,
  AddRiskRegisterForm,
  getWorkstreamUsers,
  SaveMatrixColor,
  MatrixColor,
  RiskRegisterCalculation,
  MitigationCalculation,
  UserPasswordReset,
  GetHeatmapConfiguration,
  getRiskwellColumnsForRisk,
  addExcelTemplate,
  getExcelTemplates,
  deleteExcelTemplate,
  getExcelTemplateById,
  updateExcelTemplate,
  getRiskwellColumnsForAction,
  saveRisksByExcelUpload,
  saveActionsByExcelUpload,
  commitRisksByExcelUpload,
  commitActionsByExcelUpload,
  getTemporaryRiskListForUploader,
  getTemporaryActionListForUploader,
  fetchPendingCommitForWorkstream,
  saveColumnSettings,
  getColumnSettings,
  getEffortUnitsForTasks,
  addTaskRegisterAsync,
  getTasksById,
  deleteTask,
  getTaskMetricsAsync,
  addTaskAction,
  deleteTaskAction,
  homeTaskActionsByOwner,
  homeTasksByOwner,
  getTaskActionsByWorkstreamId,
  getTaskDatasetView,
  getTaskDatasetList,
  getTaskActionDatasetView,
  getTaskActionDatasetList,
  getPriorityRankings,
  getFieldsForDataset,
  getTaskPersistence,
  addTaskPersistence,
  copyTasks,
  getOwnersByTask,
  getRiskwellColumnsForTasks,
  getRiskwellColumnsForTaskActions,
  SaveTasksByExcelUpload,
  SaveTaskActionsByExcelUpload,
  CommitTasksByExcelUpload,
  CommitTaskActionsByExcelUpload,
  GetTemporaryTaskListForUploader,
  GetTemporaryTaskActionsListForUploader,
  updateUserWorkstreamSettings,
  updateWidgetDetails
};
